var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "37px",
    height: "35px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    fill: "white",
    id: "clip39"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 51 115  L 82 115  L 82 134  L 51 134  Z M 47 106  L 84 106  L 84 141  L 47 141  Z ",
    fillRule: "evenodd"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -47 -106 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 47.5 106.5  L 83.5 106.5  L 83.5 140.5  L 47.5 140.5  L 47.5 106.5  Z ",
    fillRule: "nonzero",
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.5 106.5  L 83.5 106.5  L 83.5 140.5  L 47.5 140.5  L 47.5 106.5  Z ",
    strokeWidth: 1,
    stroke: "#797979",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 47.3839904489618 106.363234208477  L 83.6160095510382 140.636765791523  M 83.6160095510382 106.363234208477  L 47.3839904489618 140.636765791523  ",
    strokeWidth: 1,
    stroke: "#797979",
    fill: "none",
    mask: "url(#clip39)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipIcon);
export default __webpack_public_path__ + "static/media/ship_icon.0a5d17fb03ba579a7d81dfd3490a14c0.svg";
export { ForwardRef as ReactComponent };